var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    _vm.loading
      ? _c("div", [_c("loading", { attrs: { show: _vm.loading } })], 1)
      : _c("div", { staticStyle: { position: "relative", height: "100%" } }, [
          !_vm.valid
            ? _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "font-40",
                    staticStyle: {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      color: "#000",
                      transform: "translate(-50%, -50%)"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("InvalidData")))]
                )
              ])
            : _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c(
                    "swiper",
                    {
                      ref: "postureSwiper",
                      attrs: { options: _vm.swiperOption }
                    },
                    [
                      _c(
                        "swiper-slide",
                        { staticClass: "cover" },
                        [
                          _c("posture_home", {
                            attrs: { coverInfo: _vm.coverInfo },
                            on: {
                              slideIn: function($event) {
                                _vm.slideIn(1)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("swiper-slide", [
                        _c(
                          "div",
                          {
                            staticClass: "container-box",
                            staticStyle: {
                              padding: ".6rem",
                              background: "#e2edff"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content-row content-row-around content-align-center posture-view-box",
                                staticStyle: { background: "#fff" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content-row content-row-column content-row-between",
                                    staticStyle: { width: "auto" }
                                  },
                                  [
                                    _c("Posture_front", {
                                      attrs: {
                                        points: _vm.points,
                                        photos: _vm.photos,
                                        severeRisks: _vm.severeRisks,
                                        mildRisks: _vm.mildRisks,
                                        normalRisks: _vm.normalRisks
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content-row content-row-center content-align-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "face-icon view-icon"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "content-row content-row-column content-align-center",
                                            staticStyle: {
                                              width: "auto",
                                              color: "#47a8cd"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-26",
                                                staticStyle: {
                                                  "line-height": "1.5rem"
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.$t("front")))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-14",
                                                staticStyle: {
                                                  color: "#d8ebf5"
                                                }
                                              },
                                              [_vm._v("Orthographic view")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content-row content-row-column content-row-between",
                                    staticStyle: { width: "auto" }
                                  },
                                  [
                                    _c("Posture_flank", {
                                      attrs: {
                                        points: _vm.points,
                                        photos: _vm.photos,
                                        severeRisks: _vm.severeRisks,
                                        mildRisks: _vm.mildRisks,
                                        normalRisks: _vm.normalRisks
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "content-row content-row-center content-align-center"
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "side-icon view-icon"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "content-row content-row-column content-align-center",
                                            staticStyle: {
                                              width: "auto",
                                              color: "#47a8cd"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-26",
                                                staticStyle: {
                                                  "line-height": "1.5rem"
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.$t("side")))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-14",
                                                staticStyle: {
                                                  color: "#d8ebf5"
                                                }
                                              },
                                              [_vm._v("Side view")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "swiper-slide",
                        [
                          _c("Posture_sympipad", {
                            attrs: {
                              severeRisks: _vm.severeRisks,
                              mildRisks: _vm.mildRisks,
                              normalRisks: _vm.normalRisks
                            },
                            on: { setModalInfo: _vm.setModalInfo }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.MuscleShow == true
                        ? _c("Posture_report", {
                            attrs: { updateSwiper: _vm.updateSwiper },
                            on: {
                              slideIn: _vm.slideIn,
                              updateSwiper: _vm.updateSwiperIndex
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-pagination posture-swiper-pagination content-row content-row-center",
                        attrs: { slot: "pagination" },
                        slot: "pagination"
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.modalInfo
                    ? _c(
                        "div",
                        {
                          staticClass: "posture-modal",
                          staticStyle: { "background-color": "#c5c5c6" }
                        },
                        [
                          _c(
                            "b-modal",
                            {
                              ref: "riskModalRef",
                              attrs: {
                                size: "lg",
                                title: "Large Modal",
                                "hide-footer": "",
                                "hide-header": ""
                              },
                              on: { shown: _vm.initRiskBar }
                            },
                            [
                              _c("Posture_modal_ipad", {
                                attrs: { modalInfo: _vm.modalInfo },
                                on: { hideModal: _vm.hideModal }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b4fd451", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4fd451","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_ipad.vue
// module id = null
// module chunks = 